"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const faEye_1 = require("@fortawesome/pro-regular-svg-icons/faEye");
const faEyeSlash_1 = require("@fortawesome/pro-regular-svg-icons/faEyeSlash");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const translate_1 = require("components/translate");
const VisibilityStatus = ({ isVisible = false }) => {
    const visibilityClasses = (0, classnames_1.default)('_text-nowrap', {
        '_text-blue': isVisible,
        '_text-gray-700': !isVisible
    });
    return ((0, jsx_runtime_1.jsxs)("span", { className: visibilityClasses, children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: isVisible ? faEye_1.faEye : faEyeSlash_1.faEyeSlash, className: "_mr-4" }), (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: `class_manager.class_editor.list_modules.${isVisible ? 'visible' : 'hidden'}` })] }));
};
exports.default = VisibilityStatus;
